module.exports = __webpack_public_path__ + "img/dzlogo.c7775427.png";